"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LANDING_PAGE = void 0;
const LANDING_PAGE = exports.LANDING_PAGE = 'landing-page';
